import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertModule } from 'ngx-bootstrap/alert';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { TreeModule } from 'primeng/tree';
import { TableModule } from 'primeng/table';
import { MVMSpinnerBtnModule } from '../mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { SharedValidatorsModule } from '../validators/shared-validators.module';
import { AssistedSelfServiceInvitationModalComponent } from './assisted-self-service-invitation/assisted-self-service-invitation-modal.component';
import { AutoCompleteComponent } from './autocomplete/autocomplete.component';
import { ViewErrorsButtonComponent } from './button/view-errors-button.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { DocumentImageComponent } from './document/document-image.component';
import { DocumentLaunchModalComponent } from './document/document-launch-modal.component';
import { DocumentRetriveUploadComponent } from './document/document-retrieve-upload.component';
import { DocumentScanLaterComponent } from './document/document-scan-later.component';
import { DocumentSearchModalComponent } from './document/document-search-modal.component';
import { DocumentSearchComponent } from './document/document-search.component';
import { DocumentUploadModalComponent } from './document/document-upload-modal.component';
import { UpsertDocumentRequirementsModalComponent } from './document/upsert-document-requirements-modal.component';
import { AddFeeModalComponent } from './fees/add-fee-modal.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FilterComponent } from './filter/filter.component';
import { HelpLinkComponent } from './help-panel/help-link.component';
import { HelpPanelComponent } from './help-panel/help-panel.component';
import { JsonViewerComponent } from './json-viewer/json-viewer.component';
import { CalendarComponent } from './max-calendar/max-calendar.component';
import { SharedComponentsModalModule } from './modals/sharedcomponents-modal.module';
import { TextAreaModalComponent } from './modals/textarea-modal.component';
import { NavigationBarComponent } from './navigation/navigation-bar.component';
import { OmegaDetailModalComponent } from './omega/omega-details-update-modal.component';
import { DocumentViewerComponent } from './output/document-viewer.component';
import { PrintViewModalComponent } from './output/print-view.component';
import { PrintComponent } from './output/print.component';
import { SelectListComponent } from './select-list/select-list.component';
import { ValidationResultsModule } from './validation-results/validation-results.module';
import { MaxImageCropperComponent } from './max-image-cropper/max-image-cropper.component';
import { SharedPipesModule } from '../pipes/shared-pipes.module';
import { PhotoCaptureComponent } from './photo-capture/photo-capture.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { ReturnButtonComponent } from './button/return-button.component';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [
        AddFeeModalComponent,
        AssistedSelfServiceInvitationModalComponent,
        AutoCompleteComponent,
        CalendarComponent,
        CheckboxComponent,
        DocumentImageComponent,
        DocumentLaunchModalComponent,
        DocumentRetriveUploadComponent,
        DocumentScanLaterComponent,
        DocumentSearchComponent,
        DocumentSearchModalComponent,
        DocumentUploadModalComponent,
        DocumentViewerComponent,
        FileUploadComponent,
        FilterComponent,
        HelpLinkComponent,
        HelpPanelComponent,
        JsonViewerComponent,
        MaxImageCropperComponent,
        NavigationBarComponent,
        OmegaDetailModalComponent,
        PrintComponent,
        PrintViewModalComponent,
        SelectListComponent,
        TextAreaModalComponent,
        UpsertDocumentRequirementsModalComponent,
        ViewErrorsButtonComponent,
        PhotoCaptureComponent,
        ReturnButtonComponent
    ],
    imports: [
        AlertModule,
        CalendarModule,
        CommonModule,
        DropdownModule,
        FileUploadModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        InputMaskModule,
        InputNumberModule,
        MVMSpinnerBtnModule,
        ReactiveFormsModule,
        SharedComponentsModalModule,
        SharedValidatorsModule,
        SharedPipesModule,
        TableModule,
        TreeModule,
        ValidationResultsModule,
        RouterModule
    ],
    exports: [
        AssistedSelfServiceInvitationModalComponent,
        AutoCompleteComponent,
        CalendarComponent,
        CheckboxComponent,
        DocumentImageComponent,
        DocumentRetriveUploadComponent,
        DocumentScanLaterComponent,
        DocumentSearchComponent,
        DocumentViewerComponent,
        FileUploadComponent,
        FilterComponent,
        HelpLinkComponent,
        HelpPanelComponent,
        JsonViewerComponent,
        MaxImageCropperComponent,
        NavigationBarComponent,
        OmegaDetailModalComponent,
        PrintComponent,
        PrintViewModalComponent,
        SelectListComponent,
        ViewErrorsButtonComponent,
        PhotoCaptureComponent,
        ViewErrorsButtonComponent,
        ReturnButtonComponent
    ]
})
export class SharedComponentsModule {
}
